<template>
  <section v-if="canAccessLockedPages">
    <slot></slot>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PasswordProtectedSection',
  computed: {
    ...mapGetters({
      canAccessLockedPages: 'user/canAccessLockedPages',
    }),
  },
};
</script>

<style lang="scss" scoped></style>
